import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import { UIHeader, validate, AppModel } from "galaxy-framework";
import {EventBus, FunctionItem } from 'marmot_design_ui'
import Cookies from 'js-cookie'
import Qs from 'qs'
import {eventTrackingReport} from '@/utils'
// components
import { CollapsedMenu } from './collapsedMenu'
import {Layout, Breadcrumb, Menu} from 'antd'

// model
import ETBaseDataModel from '@/eventTracking/model/baseData'
// service
import AppService from './service'
import EventTrackingService from '@/eventTracking/service'

// redux
import { IRootState } from '@/redux';
import { connect } from 'react-redux';
import { setEventTrackingData } from '@/eventTracking/redux-eventTracking.reducer'

import './style.less'

const { SubMenu } = Menu;
const { Content } = Layout;

interface iProps extends iStateProps, iDispatchProps, RouteComponentProps {
  children: React.ReactNode;
  appName: string;
  appModel?: AppModel;
  leftMenuApi?: string;
  topBarUrl?: string;
  enumUrl?: string
}
interface iState {
  app: AppModel;
  breadcrumbItem: string[];
  selectedKeys: string[],
  hiddenLeftMenu?: boolean;
  collapsed: boolean;
  eTBaseData: ETBaseDataModel[], // 埋点数据
  isReporting: boolean // 埋点数据是否正在上报中
}
let eventTracking = null // 埋点定时器，每15s请求一次
let windowMonitor = null // 浏览器窗口监听
let windowunload = null

class App extends Component<iProps, iState> {
  private appService: AppService = new AppService()
  private eventTrackingService: EventTrackingService = new EventTrackingService()
  state: iState = {
    app: new AppModel(),
    breadcrumbItem: [],
    selectedKeys: [],
    hiddenLeftMenu: (window.location.pathname.indexOf('/register') > -1 || window.location.pathname.indexOf('spcmgr') > -1 ? true: false),
    collapsed: true,
    eTBaseData: [], // 埋点数据
    isReporting: false
  };
  async componentWillMount() {
    await this.validate();
    this.props.history.listen((location, action) => {
      let { pathname } = location;
      this.setState({ hiddenLeftMenu: (window.location.pathname.indexOf('detailsofspace') > -1 || window.location.pathname.indexOf('spcmgr') > -1  ? true: false) });
      let selectedKey = this.findUrl(pathname);
      this.setState({ selectedKeys: [selectedKey] });
    });
    await this.getAppInfo();
    // await this.getBaseData();
    if (this.props.location.pathname === "/") {
      this.props.history.replace({
        pathname: this.state.app.functionItems[0].url,
      });
      this.setState({ selectedKeys: [this.state.app.functionItems[0].url] });
    } else {
      this.setState({ selectedKeys: [this.findUrl(this.props.location.pathname)] });
    }
  }
  componentDidMount () {
    // 开启定时器，每15s进行一次数据上报
    eventTracking = setInterval(this.reportEventTracking, 15000)
    // 判断浏览器的支持情况 
    if (typeof document.addEventListener === "undefined" || typeof document['hidden'] === "undefined") { 
      console.log("This demo requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API."); 
    } else {
      let hidden, visibilityChange;
      if (typeof document.hidden !== "undefined") {  
        hidden = "hidden"; 
        visibilityChange = "visibilitychange"; 
      } else if (typeof document['msHidden'] !== "undefined") { 
        hidden = "msHidden"; 
        visibilityChange = "msvisibilitychange"; 
      } else if (typeof document['webkitHidden'] !== "undefined") { 
        hidden = "webkitHidden"; 
        visibilityChange = "webkitvisibilitychange"; 
      }
      windowMonitor = document.addEventListener(visibilityChange, () => {
        if (document.visibilityState === 'hidden') {
          this.reportEventTracking()
        } else { 
          console.log('浏览器获得焦点')
        } 
      }, false);
    }
    windowunload = window.addEventListener("unload", () => console.log('页面刷新'))
  }
  componentWillUnmount () {
    eventTracking && clearInterval(eventTracking)
    windowMonitor = null
    windowunload = null
  }
  // 上报数据
  reportEventTracking = async () => {
    if (!this.state.isReporting) { // 数据正在上报中
      if (this.props.eventTrackingData && this.props.eventTrackingData.length) {
        try {
          let eventTrackingData = this.props.eventTrackingData.map(item =>  ({...item, uId: this.state.app.user.userId ?? ''}))
          this.setState({isReporting: true})
          eventTrackingReport('/leco/ecology/api/v1/stat/group/report', eventTrackingData)
          .then(() => {
            this.setState({isReporting: false})
            this.props.setEventTrackingData([])
          }).catch(() => {
            this.setState({isReporting: false})
            this.props.setEventTrackingData([])
          })
        }
        catch {
          console.log('上报出错')
          this.setState({isReporting: false})
          this.props.setEventTrackingData([])
        }
      }
    } else {
      console.log('数据正在上报中，切勿重复上报')
    }
  }
  findUrl = (pathname:string):string => {
    let selectedKey: string = "";
    for (let functionItem of this.state.app.functionItems) {
      let { url = "" } = functionItem;
      if (url && pathname.startsWith(url)) {
        selectedKey = url;
        break;
      } else if (functionItem.subFunctionItems) {
        for (let subFunctionItem of functionItem.subFunctionItems) {
          if (subFunctionItem.url && pathname.startsWith(subFunctionItem.url)) {
            selectedKey = subFunctionItem.url;
            break;
          }
        }
      }
    }
    return selectedKey;
  };
  // 检验token有效性
  async validate() {
      let {data}= await validate(Cookies.get('token'));
      if(data=='ok'){
          (document.querySelector("#root") as HTMLDivElement).style.display="block";
          (document.querySelector("#splash") as HTMLDivElement).style.display="none";
      }else{
          window.location.replace(`/fe-pc/fe_newlogin/login?fromUrl=${window.location.href}`)
      }
  }
  async getAppInfo() {
    let { appName, appModel=null, topBarUrl, leftMenuApi } = this.props;
    let app:AppModel;
    if(!appModel)
    app= await this.appService.getAppInfo({appName, topBarUrl, leftMenuApi});
    else
    app=appModel;
    await this.setState({ app });
    let paths = this.findPathByKey(this.props.location.pathname);

    console.log(app.menuItems,'menuItemsmenuItems')
    let breadcrumbItem = [
      app.menuItems.find((menuItem) => menuItem.appName === appName).name,
      ...paths
    ];

    console.log(
      breadcrumbItem,'breadcrumbItem'
      
      )
    this.setState({ breadcrumbItem });
  }
  getMenu = (functionItems: FunctionItem[]): JSX.Element[] => {
    let list: Array<JSX.Element> = [];
    list = functionItems && functionItems.length && functionItems.map((functionItem: FunctionItem, index: number) =>
    functionItem.subFunctionItems && functionItem.subFunctionItems.length ? (
        <SubMenu
          key={functionItem.functionId}
          title={
            <span style={{ display: "flex" }}>
              <img
                alt=""
                width="26"
                height="48"
                src={functionItem.icon}
                style={{ display: "flex", paddingRight: 8 }}
              />
              <span>{functionItem.name}</span>
            </span>
          }
        >
          {this.getMenu(functionItem.subFunctionItems)}
        </SubMenu>
      ) : (
        <Menu.Item key={functionItem.url}>
          <span style={{ display: "flex" }}>
            {functionItem.icon && 
            <img
              alt=""
              width="26"
              height="48"
              src={functionItem.icon}
              style={{ display: "flex", paddingRight: 8 }}
            />}
            <span>
              {functionItem.name}
            </span>
          </span>
        </Menu.Item>
      )
    );
    return list;
  }
  findPathByKey = (key: string): string[] => {
    for (let item of this.state.app.functionItems) {
      if (item.url === key) {
        return [item.name];
      } else if (item.subFunctionItems && item.subFunctionItems.length) {
        for (let subItem of item.subFunctionItems) {
          if (subItem.url === key) {
            return [item.name, subItem.name];
          }
        }
      }
    }
    return [];
  };
  goto = ({ item, key, keyPath, domEvent }: any) => {
    let paths = this.findPathByKey(key);
    let { breadcrumbItem } = this.state;
    this.setState({ breadcrumbItem: [breadcrumbItem[0], ...paths] });
    EventBus.emit("on-menuitem-click");
    this.props.history.push({ pathname: key });
  }
  collapsedChange = collapsed => {
    this.setState({collapsed})
  };
  render() {
    let { children, appName } = this.props;
    let { app, breadcrumbItem, selectedKeys, hiddenLeftMenu=false,
        collapsed } = this.state;
    return (
      <Layout style={{ minHeight: "100vh" }} className="reportcenter_index">
        <UIHeader
          hasSearchBar={app.hasSearchBar}
          menuItems={app.menuItems}
          avatar={app.user.avatar}
          userName={app.user.username}
          fullName={app.user.fullName}
          name={app.tenant.appName}
          schoolName={app.tenant.name}
          appName={appName}
          logo={app.tenant.logo}
        />
        <Layout style={{ marginTop: 48 }}>
        {!hiddenLeftMenu&&
        <CollapsedMenu 
        user={app.user}
        onChange={this.collapsedChange}
        goto={this.goto}
        menuData={app.functionItems}
        menuSelectKeys={selectedKeys}
      ></CollapsedMenu>}
          <Layout
            style={{
              padding: `0 24px 0 ${hiddenLeftMenu?'24px':'16px'}`,
              marginLeft: hiddenLeftMenu ? 0 : (collapsed ? 64:180),
              backgroundColor: "#F0F2F5",
            }}
            className="main"
          >
            {!hiddenLeftMenu&&<Breadcrumb
              style={{
                padding: "17px 0 8px",
                width: "100%",
                backgroundColor: "#f0f2f5",
                fontSize: "14px"
              }}
            >
              {breadcrumbItem.map((item, index) => (
                <Breadcrumb.Item key={index}>{item}</Breadcrumb.Item>
              ))}
            </Breadcrumb>}
            <Content
              style={{
                margin: '16px 0',
                marginTop: 0, 
                minHeight: 280,
              }}
            >
              <Layout>
                <Content>
                  {children}
                </Content>
              </Layout>
            </Content>
          </Layout>
        </Layout>
        {/* <Footer style={{ textAlign: "center" }}>技术支持 博校科技</Footer> */}
      </Layout>
    );
  }
}
const mapStateToProps = (state: IRootState) => {
  return {
    eventTrackingData: state.eventTrackingState.eTBaseDataModel,
  };
};
const mapDispatchToProps = {
  setEventTrackingData,
};
type iStateProps = ReturnType<typeof mapStateToProps>;
type iDispatchProps = typeof mapDispatchToProps;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);